module.exports = __webpack_public_path__ + "img/logo2.5e92b54a.png";